import {FileConfiguration} from '../../file/message/FileConfiguration';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class FtpFileConfiguration extends PredefinedBaseConfiguration {
cnxCode: string;
destinationFile: FileConfiguration;
originFile: FileConfiguration;
}

